import { Component, OnInit, ViewChild, ElementRef, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TrainingService } from '../training.service';
import { EmployeeTraining, TrainingQuestion } from '../training';

import Player, { VimeoEmbedParameters, VimeoUrl } from '@vimeo/player';

@Component({
    selector: 'eup-train-wizard',
    templateUrl: './train-wizard.component.html',
    styleUrls: ['./train-wizard.component.scss'],
    standalone: false,
})
export class TrainWizardComponent implements OnInit {
    #activeroute = inject(ActivatedRoute);
    #router = inject(Router);
    #service = inject(TrainingService);
    #destroyRef = inject(DestroyRef);

    training: EmployeeTraining;

    videoUrl: string;

    private player: Player;

    startPlayer(container: ElementRef): void {
        let c = this;
        if (container) {
            const options: VimeoEmbedParameters = {
                url: c.videoUrl as VimeoUrl,
                width: 1115,
                height: 650,
                autoplay: true,
                fullscreen: true,
                pip: true,
            };
            this.player = new Player(container.nativeElement, options);
            this.player.on('ended', function () {
                c.videoFinished = true;
            });
        }
    }

    @ViewChild('player_container', { static: false }) set _playerContainer(value: ElementRef) {
        this.startPlayer(value);
    }

    videoFinished: boolean;

    ngOnInit(): void {
        this.#activeroute.paramMap
            .pipe(
                switchMap((p) => this.#service.startEmployeeTraining(p.get('id'))),
                takeUntilDestroyed(this.#destroyRef)
            )
            .subscribe((training) => {
                this.training = training;
                console.log(this.training);
                this.videoFinished = false;

                this.refreshVideo();
            });
    }

    refreshVideo() {
        if (this.training && this.training.definition.videoUrl)
            this.videoUrl = this.training.definition.videoUrl;
    }

    get question(): TrainingQuestion {
        if (
            this.training &&
            this.training.step > 0 &&
            this.training.definition.questions.length > this.training.step - 1
        )
            return this.training.definition.questions[this.training.step - 1];

        return null;
    }

    videoWatched() {
        this.training.definition.videoWatched = true;
        this.training.step++;
        this.updateTraining();
    }

    goToVideo() {
        this.training.step = 0;
        this.training.finished = false;
        this.training.successful = false;
        this.updateTraining();
    }

    prevStep() {
        this.training.step--;
        this.updateTraining();
    }

    nextStep() {
        this.training.step++;
        this.updateTraining();
    }

    updateTraining() {
        if (!this.training.finished)
            this.#service.updateEmployeeTraining(this.training).subscribe((updatedTraining) => {
                this.training = updatedTraining;
                console.log(this.training);

                this.refreshVideo();
            });
    }

    postTraining() {
        if (this.training.successful)
            this.#service.submitEmployeeTraining(this.training).subscribe(() => {
                this.#router.navigateByUrl('/dashboard');
            });
    }

    retakeQuiz() {
        this.#service
            .restartEmployeeTraining(this.training)
            .subscribe((updatedTraining: EmployeeTraining) => {
                this.training = updatedTraining;
            });
    }

    restartTraining() {
        this.#service
            .restartEmployeeTraining(this.training)
            .subscribe((updatedTraining: EmployeeTraining) => {
                this.training = updatedTraining;
                this.training.step = 0;
                this.refreshVideo();
            });
    }
}
